import _ from 'lodash';
import validatorEmail from 'email-validator';
import validator from 'validator';
import { string } from 'prop-types';


//this is the universal funtion which gives us the error of any field in cloud.okas.ai

export default function (errorType, errorText) {
    if (errorType === 'username') {
        if (errorText.length !== 0 && errorText.indexOf(' ') === -1) {
            return 'No Error'
        } else {
            return 'Invalid Username'
        }
    } else if (errorType === 'siUsername') {
        if (errorText.length !== 0 && errorText.indexOf(' ') === -1) {
            return 'No Error'
        } else {
            return 'Invalid Username'
        }
    } else if (errorType === 'email') {
        if (validatorEmail.validate(errorText)) {
            return 'No Error'
        } else {
            return 'Please enter a valid email.'
        }

    }
    else if (errorText && errorType === 'notEmpty') {
        if (errorText.trim() !== '') {
            return 'No Error'
        } else {
            return 'Only white spaces are not allowed'
        }
    }


    else if (errorType === 'validChannelNumber') {
        console.log(errorText)
        if (Number(errorText) >= 100 && Number(errorText) <= 9999) {
            return 'No Error'
        } else {
            return 'Only white spaces are not allowed'
        }
    } else if (errorType === 'isAlphaNumeric') {
        if (validator.isAlphanumeric(errorText)) {
            return 'No Error'
        } else {
            return 'Must contain a alphanumeric characters.'
        }
    } else if (errorType === 'isAlpha') {
        if (validator.isAlpha(errorText)) {
            return 'No Error'
        } else {
            return 'Must contain alphabatical characters only.'
        }
    }
    else if (errorType === 'isMobile') {
        if (
            errorText &&
            errorText.length >= 6 &&
            errorText.length <= 15 &&
            /^[3-9][0-9]{5,14}$/.test(errorText)
        ) {
            return 'No Error';
        } else {
            return 'Must be a valid mobile number.';
        }
    }

    //  else if (errorType === 'isMobile') {
    //     if (errorText && errorText.length === 15 && Number(errorText.substring(0, 1)) >= 3) {
    //         return 'No Error'
    //     } else {
    //         return 'Must be a valid mobile number.'
    //     }
    // }
    else if (errorType === 'isOkasBoxSerialNumber') {
        if (errorText.length >= 6 && errorText.indexOf(" ") === -1 && errorText.length <= 16) {
            return 'No Error'
        } else {
            return 'Must contain 10 digits.'
        }
    } else if (errorType === 'isNumber') {
        if (!isNaN(errorText)) {
            return 'No Error'
        } else {
            return 'Must be a numeric number'
        }
    } else if (errorType === 'gst') {
        if (errorText && errorText.length === 15 && errorText.match(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/)) {
            return 'No Error'
        } else {
            return 'Not a valid GST Number'
        }
    } else if (errorType === 'isChannel') {
        if (errorText.length >= 3 && errorText.length <= 4) {
            if (Number(errorText) >= 99 && Number(errorText) <= 9999) {
                return 'No Error'
            } else {
                return 'Invalid channel number'
            }
        } else {
            return 'Invalid channel number.'
        }
    } else if (errorType === 'isChannelName') {
        if (errorText.length !== 0) {
            if (validator.isAscii(errorText)) {
                return 'No Error'
            } else {
                return 'Invalid channel name.'
            }
        } else {
            return "Invalid channel name"
        }
    } else if (errorType === 'isPDF') {
        // File validation for PDF
        const validPDFTypes = ['application/pdf'];
        if (validPDFTypes.includes(errorText.type)) {
            return 'No Error';
        } else {
            return 'Please upload a valid PDF file';
        }
    } else if (errorType === 'validUrl') {
        const urlPattern = /^(https?:\/\/)((localhost|[\w-]+(\.[\w-]+)+)|(\d{1,3}\.){3}\d{1,3})(:\d+)?(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
        return urlPattern.test(errorText) ? 'No Error' : 'Invalid URL';
    }

}